import { Link } from '@/i18n/routing';
import type { ReactNode } from 'react';
import { useToggle } from '../../../../../../hooks';

interface ChildrenArgs {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

interface Props {
  children: ((args: ChildrenArgs) => ReactNode) | ReactNode;
  hiddenMenu?: boolean;
  fullWidth?: boolean;
  label: string;
  onLabelClick?: () => void;
  href?: {
    pathname: string;
    query?: { [key: string]: string };
    params?: { [key: string]: string };
  };
}

function FlyoutMenu({
  children,
  fullWidth = false,
  hiddenMenu = false,
  label,
  href,
}: Props) {
  const { isOpen, open, close } = useToggle();

  return (
    <div className="group/flyout" onMouseEnter={open} onMouseLeave={close}>
      {href?.pathname ? (
        <Link
          // @ts-ignore
          href={href}
          className={`block no-underline text-sm lg:text-base font-medium tracking-tight text-greyscale-label py-3 group-hover/flyout:text-greyscale-title border-b-2
            ${isOpen ? 'border-b-greyscale-body' : 'border-b-transparent'}
          `}
        >
          {label}
        </Link>
      ) : (
        <div
          className={`block no-underline text-sm lg:text-base font-medium tracking-tight text-greyscale-label py-3 group-hover/flyout:text-greyscale-title border-b-2
            ${isOpen ? 'border-b-greyscale-body' : 'border-b-transparent'}
          `}
        >
          {label}
        </div>
      )}

      {isOpen && !hiddenMenu && (
        <div
          className={`absolute top-full ${
            fullWidth ? 'inset-x-0' : '-ml-6'
          }`}
        >
          <div
            className={`relative bg-white border-y border-greyscale-separator shadow-lg overflow-hidden ${
              fullWidth ? '' : 'rounded-2xl'
            }`}
          >
            {typeof children === 'function'
              ? children({ isOpen, open, close })
              : children}
          </div>
        </div>
      )}
    </div>
  );
}

export default FlyoutMenu;
